import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TaskDb } from 'lib/cosmos/task/taskDb.js';
import { ITable } from 'lib/ui/table/index.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
	templateUrl: './list-my-tasks.component.html',
	selector: 'mod-list-my-tasks',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ListMyTasksComponent extends TypeCoreComponent {
	public readonly table = signal<ITable<TaskDb.ITaskItem> | undefined>(undefined);
	public readonly defaultTable = signal<ITable<TaskDb.ITaskItem> | undefined>(undefined);

	constructor() {
		super();

		this.dataInit = () => {
			this.initTasks();
		};
	}

	private initTasks(): void {
		super.subscribeToObservable(
			this.dependencies.httpService.listGlobalAndOwned<TaskDb.ITaskItem>('task').pipe(
				map((response) => {
					this.defaultTable.set(
						this.dependencies.coreAppService.getGlobalTableConfig({
							itemType: 'Task',
							items: response.data.globalItems,
							subtitle: (item) => item.description
						})
					);

					this.table.set({
						itemType: 'Task',
						search: {
							type: 'local'
						},
						noItemsText: {
							noItems: `You have no custom tasks`,
							noFilteredItems: `No task matches your filter`
						},
						tableButtons: [
							{
								icon: 'add',
								buttonType: 'primary',
								buttonSize: 'default',
								routerLink: this.dependencies.navigateService
									.actionRoute((routes) => routes.taskRoutes.tasks.children.new)
									.getUrl(),
								title: `New task`
							}
						],
						avatar: (item) => {
							return {
								name: item.system.name,
								image: item.avatar?.[0]?.image
							};
						},
						deleteItems: (items) => {
							return this.dependencies.httpService
								.deleteMultiple<TaskDb.ITaskItem>(
									'task',
									items.map((m) => m.id)
								)
								.pipe(
									map((response) => {
										return items;
									})
								);
						},
						items: response.data.ownedItems,
						id: (item) => item.id,
						title: {
							title: 'Tasks',
							value: (item) => item.system.name
						},
						mainRouterLink: (item) =>
							this.dependencies.navigateService
								.actionRoute((routes) => routes.taskRoutes.task.children.edit, item.id)
								.getUrl(),
						fields: [
							{
								format: 'date',
								title: `Updated`,
								value: (item) => this.dependencies.timeService.fromNow(item.system.updated),
								sortBy: (item) => new Date(item.system.updated),
								isDefaultSort: true
							}
						]
					});
				})
			)
		);
	}
}
